<template>
  <login-wrap class="captcha-wrap">
    <template #text>
      <div v-html="$sanitize(captchaText)" />
    </template>
    <div
      id="captcha"
      class="captcha-inline" />
  </login-wrap>
</template>

<script>
import { mapMutations } from 'vuex';

import LoginWrap from '@/components/auth/LoginWrap.vue';

import { SUPPORT_EMAIL } from '@/utils/cons.js';
import { unblockCaptcha } from '@/api';
import { logErrorWithSentry } from '@/elements/utils.js';
import EventBus from '@/elements/eventBus.js';

export default {
  name: 'LoginCaptcha',
  components: {
    LoginWrap,
  },
  computed: {
    ip() {
      return this.$store.state.auth.captchaIP;
    },
    captchaText() {
      return this.$gettextInterpolate(
        this.$gettext(
          'Our intrusion prevention system has detected apparent unauthorised access attempts and has temporarily restricted your IP %{ ip }, please complete the captcha below to release.%{ breakTag }For more information contact %{ supportEmail }.'
        ),
        {
          ip: this.ip,
          supportEmail: `<a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>`,
          breakTag: '<br>',
        },
        true
      );
    },
  },
  mounted() {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.ready(() =>
        grecaptcha.render('captcha', {
          sitekey: process.env.VUE_APP_CAPTCHA_KEY,
          callback: this.unblockCaptchaAction,
        })
      );
    }
  },
  methods: {
    ...mapMutations({
      setLoginError: 'auth/setLoginError',
      setMfaCode: 'auth/setMfaCode',
    }),
    async unblockCaptchaAction(e) {
      try {
        const xhr = await unblockCaptcha({ token: e });
        if (xhr.responseJSON.valid) {
          this.setLoginError(null);
          this.setMfaCode(this.$store.state.auth.cashedMfaCode);
        } else {
          this.setLoginError('captcha');
        }
      } catch (error) {
        EventBus.$emit('handle-error', { response: error.response });
        logErrorWithSentry(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.captcha-wrap {
  #captcha-msg {
    color: $red;
  }
}
</style>
